'use client';

import PageHeaderRoot from './PageHeaderRoot';

const PageHeaderArticleIndex = () => {
  return <PageHeaderRoot variant="articleIndex" />;
};

export default PageHeaderArticleIndex;
